import { render } from "./visualizar.vue?vue&type=template&id=0098ae0d&scoped=true"
import script from "./visualizar.vue?vue&type=script&lang=js"
export * from "./visualizar.vue?vue&type=script&lang=js"

import "./visualizar.vue?vue&type=style&index=0&id=0098ae0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0098ae0d"]])

export default __exports__